import { useColors, useStyles } from "./ui";
import { useI18n } from "./i18n";

export function ConfirmModal({ message, subMessage, onCancel, onConfirm, confirmLabel }: {
  message: string;
  subMessage?: string;
  onCancel: () => void;
  onConfirm?: () => void;
  confirmLabel?: string;
}) {
  const colors = useColors();
  const styles = useStyles();
  const { t } = useI18n();
  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(0,0,0,0.25)" }}
      onClick={onCancel}>
      <div style={{ background: colors.bg, border: `1px solid ${colors.border}`, boxShadow: "0 8px 24px rgba(0,0,0,0.2)", padding: "1rem 1.25rem", borderRadius: "6px", display: "flex", flexDirection: "column", gap: "0.75rem", minWidth: "16rem", maxWidth: "24rem", textAlign: "center" }}
        onClick={(e) => e.stopPropagation()}>
        <div style={{ fontSize: "0.9rem", color: colors.text }}>{message}</div>
        {subMessage && <div style={{ fontSize: "0.8rem", color: colors.textMuted }}>{subMessage}</div>}
        <div style={{ display: "flex", gap: "0.5rem", justifyContent: "center" }}>
          <button style={{ ...styles.btn, fontSize: "0.8rem", padding: "0.3rem 0.75rem" }} onClick={onCancel}>{t("common.cancel")}</button>
          {onConfirm && (
            <button style={{ ...styles.btnPrimary, fontSize: "0.8rem", padding: "0.3rem 0.75rem", background: colors.danger }} onClick={onConfirm}>
              {confirmLabel ?? t("common.delete")}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
